<template>
    <div ref="info" class="info  flex flex-direction">
        <div v-if="state === 3" class="reason red margin-bottom-sm"><span>拒绝原因:</span>{{ season }}</div>
        <div v-if="state === 2" class="reason  margin-bottom-sm"><span>已通过</span></div>
        <el-form
            ref="infoForm"
            :model="infoForm"
            :rules="rules"
            class="info-form"
            label-width="250px">
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="mune-title first">一、综合实力</div>
                    <div class="mune-title margin-top-sm">1.实力信息</div>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="注册资本：" prop="register_capital">
                        <el-select
                            v-model="infoForm.register_capital"
                            :disabled="readonly"
                            class="w-all" placeholder="请选择注册资本">
                            <el-option
                                v-for="item in moneyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="连续经营年限：" prop="register_years">
                        <el-select
                            v-model="infoForm.register_years"
                            :disabled="readonly"
                            class="w-all" placeholder="请选择连续经营年限">
                            <el-option
                                v-for="item in jYearList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="社保员工人数：" prop="social_security_number">
                        <el-select
                            v-model="infoForm.social_security_number"
                            :disabled="readonly"
                            class="w-all" placeholder="请选择社保员工人数">
                            <el-option
                                v-for="item in sheBaoNumberList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="会员年限：" prop="member_years">
                        <el-select
                            v-model="infoForm.member_years"
                            :disabled="readonly"
                            class="w-all" placeholder="请选择会员年限">
                            <el-option
                                v-for="item in vipYearList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="消防技术服务从业条件：" prop="practice_condition">
                        <el-select
                            v-model="infoForm.practice_condition"
                            :disabled="readonly"
                            class="w-all" multiple
                            placeholder="请选择消防技术服务从业条件"
                            @change="(e)=>{return classifyChange(e,'practice_condition_file','serviceList')}">
                            <el-option
                                v-for="item in serviceList"
                                :key="item.value"
                                :disabled="(infoForm.practice_condition.indexOf(0) !== -1 && item.value !== 0)
                                || (infoForm.practice_condition.filter(f=> {return f !==0 }).length > 0 && item.value === 0)"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-table
                        v-if="infoForm.practice_condition_file.filter(item=>{return item.id !== 0}).length > 0"
                        :data="infoForm.practice_condition_file.filter(item=>{return item.id !== 0})"
                        border
                        class="margin-bottom-sm"
                        style="width: 100%">
                        <el-table-column label="名称" prop="name" width="220">
                        </el-table-column>
                        <el-table-column label="附件">
                            <template slot-scope="scope">
                                <div v-if="scope.row.name.indexOf('其他') !== -1" class="flex flex-direction">
                                    <el-button v-if="!readonly" class="self-end" plain size="mini"
                                               type="primary" @click="addItem('practice_condition_file',scope.$index)">
                                        添加
                                    </el-button>
                                    <div v-for="(item,index) in scope.row.content" :key="index" class="other flex flex-direction">
                                        <el-form-item :prop="'practice_condition_file.' + scope.$index + '.content.'+ index + '.name'"
                                                      :rules="{required: true, message: '请输入其他描述', trigger: 'blur'}"
                                                      label-width="0">
                                            <div class="flex align-center justify-between">
                                                <el-input v-model="item.name" :disabled="readonly" placeholder="请输入其他描述" size="mini"></el-input>
                                                <el-button v-if="!readonly" class="margin-left" plain size="mini"
                                                           type="danger"
                                                           @click="delItem('practice_condition_file',scope.$index,index)">
                                                    删除
                                                </el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :prop="'practice_condition_file.' + scope.$index + '.content.'+ index + '.file'"
                                                      :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}"
                                                      label-width="0">
                                            <el-upload
                                                :action="udhost + '/api/index/upload'"
                                                :data="fileData"
                                                :disabled="readonly"
                                                :file-list="item.file"
                                                :name="'file'"
                                                :on-preview="handlePreview"
                                                :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'practice_condition_file',scope.$index,index)}"
                                                :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'practice_condition_file',scope.$index,index)}"
                                                multiple>
                                                <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件
                                                </el-button>
                                            </el-upload>

                                        </el-form-item>
                                    </div>
                                </div>
                                <el-form-item v-else
                                              :prop="'practice_condition_file.' + scope.$index + '.file'"
                                              :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}" label-width="0">
                                    <el-upload
                                        :action="udhost + '/api/index/upload'"
                                        :data="fileData"
                                        :disabled="readonly"
                                        :file-list="scope.row.file"
                                        :name="'file'"
                                        :on-preview="handlePreview"
                                        :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'practice_condition_file',scope.$index)}"
                                        :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'practice_condition_file',scope.$index)}"
                                        multiple>
                                        <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件</el-button>
                                    </el-upload>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="信息类相关资质及证书：" prop="information_qualification">
                        <el-select
                            v-model="infoForm.information_qualification"
                            :disabled="readonly"
                            class="w-all" multiple
                            placeholder="请选择信息类相关资质及证书"
                            @change="(e)=>{return classifyChange(e,'information_qualification_file','informationQualificationList')}">
                            <el-option
                                v-for="item in informationQualificationList"
                                :key="item.value"
                                :disabled="(infoForm.information_qualification.indexOf(0) !== -1 && item.value !== 0)
                                || (infoForm.information_qualification.filter(f=> {return f !==0 }).length > 0 && item.value === 0)"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-table
                        v-if="infoForm.information_qualification_file.filter(item=>{return item.id !== 0}).length > 0"
                        :data="infoForm.information_qualification_file.filter(item=>{return item.id !== 0})"
                        border
                        class="margin-bottom-sm"
                        style="width: 100%">
                        <el-table-column label="名称" prop="name" width="220">
                        </el-table-column>
                        <el-table-column label="附件">
                            <template slot-scope="scope">
                                <div v-if="scope.row.name.indexOf('其他') !== -1" class="flex flex-direction">
                                    <el-button v-if="!readonly" class="self-end" plain size="mini"
                                               type="primary"
                                               @click="addItem('information_qualification_file',scope.$index)">
                                        添加
                                    </el-button>
                                    <div v-for="(item,index) in scope.row.content" :key="index" class="other flex flex-direction">
                                        <el-form-item :prop="'information_qualification_file.' + scope.$index + '.content.'+ index + '.name'"
                                                      :rules="{required: true, message: '请输入其他描述', trigger: 'blur'}"
                                                      label-width="0">
                                            <div class="flex align-center justify-between">
                                                <el-input v-model="item.name" :disabled="readonly" placeholder="请输入其他描述" size="mini"></el-input>
                                                <el-button v-if="!readonly" class="margin-left" plain size="mini"
                                                           type="danger"
                                                           @click="delItem('information_qualification_file',scope.$index,index)">
                                                    删除
                                                </el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :prop="'information_qualification_file.' + scope.$index + '.content.'+ index + '.file'"
                                                      :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}"
                                                      label-width="0">
                                            <el-upload
                                                :action="udhost + '/api/index/upload'"
                                                :data="fileData"
                                                :disabled="readonly"
                                                :file-list="item.file"
                                                :name="'file'"
                                                :on-preview="handlePreview"
                                                :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'information_qualification_file',scope.$index,index)}"
                                                :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'information_qualification_file',scope.$index,index)}"
                                                multiple>
                                                <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件
                                                </el-button>
                                            </el-upload>

                                        </el-form-item>
                                    </div>
                                </div>
                                <el-form-item v-else :prop="'information_qualification_file.' + scope.$index + '.file'"
                                              :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}" label-width="0">
                                    <el-upload
                                        :action="udhost + '/api/index/upload'"
                                        :data="fileData"
                                        :disabled="readonly"
                                        :file-list="scope.row.file"
                                        :name="'file'"
                                        :on-preview="handlePreview"
                                        :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'information_qualification_file',scope.$index)}"
                                        :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'information_qualification_file',scope.$index)}"
                                        multiple>
                                        <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件</el-button>
                                    </el-upload>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="教育培训类相关资质及证书：" prop="education_and_training">
                        <el-select
                            v-model="infoForm.education_and_training"
                            :disabled="readonly"
                            class="w-all" multiple
                            placeholder="请选择教育培训类相关资质及证书"
                            @change="(e)=>{return classifyChange(e,'education_and_training_file','educationTrainingList')}">
                            <el-option
                                v-for="item in educationTrainingList"
                                :key="item.value"
                                :disabled="(infoForm.education_and_training.indexOf(0) !== -1 && item.value !== 0)
                                || (infoForm.education_and_training.filter(f=> {return f !==0 }).length > 0 && item.value === 0)"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-table
                        v-if="infoForm.education_and_training_file.filter(item=>{return item.id !== 0}).length > 0"
                        :data="infoForm.education_and_training_file.filter(item=>{return item.id !== 0})"
                        border
                        class="margin-bottom-sm"
                        style="width: 100%">
                        <el-table-column label="名称" prop="name" width="220">
                        </el-table-column>
                        <el-table-column label="附件">
                            <template slot-scope="scope">
                                <div v-if="scope.row.name.indexOf('其他') !== -1" class="flex flex-direction">
                                    <el-button v-if="!readonly" class="self-end" plain size="mini"
                                               type="primary"
                                               @click="addItem('education_and_training_file',scope.$index)">
                                        添加
                                    </el-button>
                                    <div v-for="(item,index) in scope.row.content" :key="index" class="other flex flex-direction">
                                        <el-form-item :prop="'education_and_training_file.' + scope.$index + '.content.'+ index + '.name'"
                                                      :rules="{required: true, message: '请输入其他描述', trigger: 'blur'}"
                                                      label-width="0">
                                            <div class="flex align-center justify-between">
                                                <el-input v-model="item.name" :disabled="readonly" placeholder="请输入其他描述" size="mini"></el-input>
                                                <el-button v-if="!readonly" class="margin-left" plain size="mini"
                                                           type="danger"
                                                           @click="delItem('education_and_training_file',scope.$index,index)">
                                                    删除
                                                </el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :prop="'education_and_training_file.' + scope.$index + '.content.'+ index + '.file'"
                                                      :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}"
                                                      label-width="0">
                                            <el-upload
                                                :action="udhost + '/api/index/upload'"
                                                :data="fileData"
                                                :disabled="readonly"
                                                :file-list="item.file"
                                                :name="'file'"
                                                :on-preview="handlePreview"
                                                :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'education_and_training_file',scope.$index,index)}"
                                                :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'education_and_training_file',scope.$index,index)}"
                                                multiple>
                                                <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件
                                                </el-button>
                                            </el-upload>

                                        </el-form-item>
                                    </div>
                                </div>
                                <el-form-item v-else
                                              :prop="'education_and_training_file.' + scope.$index + '.file'"
                                              :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}" label-width="0">
                                    <el-upload
                                        :action="udhost + '/api/index/upload'"
                                        :data="fileData"
                                        :disabled="readonly"
                                        :file-list="scope.row.file"
                                        :name="'file'"
                                        :on-preview="handlePreview"
                                        :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'education_and_training_file',scope.$index)}"
                                        :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'education_and_training_file',scope.$index)}"
                                        multiple>
                                        <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件</el-button>
                                    </el-upload>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="排油烟大气环保相关资质及证书：" prop="lampblack">
                        <el-select
                            v-model="infoForm.lampblack"
                            :disabled="readonly"
                            class="w-all" multiple
                            placeholder="请选择排油烟大气环保相关资质及证书"
                            @change="(e)=>{return classifyChange(e,'lampblack_file','lampblackList')}">
                            <el-option
                                v-for="item in lampblackList"
                                :key="item.value"
                                :disabled="(infoForm.lampblack.indexOf(0) !== -1 && item.value !== 0)
                                || (infoForm.lampblack.filter(f=> {return f !==0 }).length > 0 && item.value === 0)"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-table
                        v-if="infoForm.lampblack_file.filter(item=>{return item.id !== 0}).length > 0"
                        :data="infoForm.lampblack_file.filter(item=>{return item.id !== 0})"
                        border
                        class="margin-bottom-sm"
                        style="width: 100%">
                        <el-table-column label="名称" prop="name" width="220">
                        </el-table-column>
                        <el-table-column label="附件">
                            <template slot-scope="scope">
                                <div v-if="scope.row.name.indexOf('其他') !== -1" class="flex flex-direction">
                                    <el-button v-if="!readonly" class="self-end" plain size="mini"
                                               type="primary"
                                               @click="addItem('lampblack_file',scope.$index)">
                                        添加
                                    </el-button>
                                    <div v-for="(item,index) in scope.row.content" :key="index" class="other flex flex-direction">
                                        <el-form-item :prop="'lampblack_file.' + scope.$index + '.content.'+ index + '.name'"
                                                      :rules="{required: true, message: '请输入其他描述', trigger: 'blur'}"
                                                      label-width="0">
                                            <div class="flex align-center justify-between">
                                                <el-input v-model="item.name" :disabled="readonly" placeholder="请输入其他描述" size="mini"></el-input>
                                                <el-button v-if="!readonly" class="margin-left" plain size="mini"
                                                           type="danger"
                                                           @click="delItem('lampblack_file',scope.$index,index)">
                                                    删除
                                                </el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :prop="'lampblack_file.' + scope.$index + '.content.'+ index + '.file'"
                                                      :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}"
                                                      label-width="0">
                                            <el-upload
                                                :action="udhost + '/api/index/upload'"
                                                :data="fileData"
                                                :disabled="readonly"
                                                :file-list="item.file"
                                                :name="'file'"
                                                :on-preview="handlePreview"
                                                :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'lampblack_file',scope.$index,index)}"
                                                :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'lampblack_file',scope.$index,index)}"
                                                multiple>
                                                <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件
                                                </el-button>
                                            </el-upload>

                                        </el-form-item>
                                    </div>
                                </div>
                                <el-form-item v-else
                                              :prop="'lampblack_file.' + scope.$index + '.file'"
                                              :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}" label-width="0">
                                    <el-upload
                                        :action="udhost + '/api/index/upload'"
                                        :data="fileData"
                                        :disabled="readonly"
                                        :file-list="scope.row.file"
                                        :name="'file'"
                                        :on-preview="handlePreview"
                                        :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'lampblack_file',scope.$index)}"
                                        :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'lampblack_file',scope.$index)}"
                                        multiple>
                                        <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件</el-button>
                                    </el-upload>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="消防产品相关资质及证书：" prop="fire_products">
                        <el-select
                            v-model="infoForm.fire_products"
                            :disabled="readonly"
                            class="w-all" multiple
                            placeholder="消防产品相关资质及证书"
                            @change="(e)=>{return classifyChange(e,'fire_products_file','fireProductList')}">
                            <el-option
                                v-for="item in fireProductList"
                                :key="item.value"
                                :disabled="(infoForm.fire_products.indexOf(0) !== -1 && item.value !== 0)
                                || (infoForm.fire_products.filter(f=> {return f !==0 }).length > 0 && item.value === 0)"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-table
                        v-if="infoForm.fire_products_file.filter(item=>{return item.id !== 0}).length > 0"
                        :data="infoForm.fire_products_file.filter(item=>{return item.id !== 0})"
                        border
                        class="margin-bottom-sm"
                        style="width: 100%">
                        <el-table-column label="名称" prop="name" width="220">
                        </el-table-column>
                        <el-table-column label="附件">
                            <template slot-scope="scope">
                                <div v-if="scope.row.name.indexOf('其他') !== -1" class="flex flex-direction">
                                    <el-button v-if="!readonly" class="self-end" plain size="mini"
                                               type="primary"
                                               @click="addItem('fire_products_file',scope.$index)">
                                        添加
                                    </el-button>
                                    <div v-for="(item,index) in scope.row.content" :key="index" class="other flex flex-direction">
                                        <el-form-item :prop="'fire_products_file.' + scope.$index + '.content.'+ index + '.name'"
                                                      :rules="{required: true, message: '请输入其他描述', trigger: 'blur'}"
                                                      label-width="0">
                                            <div class="flex align-center justify-between">
                                                <el-input v-model="item.name" :disabled="readonly" placeholder="请输入其他描述" size="mini"></el-input>
                                                <el-button v-if="!readonly" class="margin-left" plain size="mini"
                                                           type="danger"
                                                           @click="delItem('fire_products_file',scope.$index,index)">
                                                    删除
                                                </el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :prop="'fire_products_file.' + scope.$index + '.content.'+ index + '.file'"
                                                      :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}"
                                                      label-width="0">
                                            <el-upload
                                                :action="udhost + '/api/index/upload'"
                                                :data="fileData"
                                                :disabled="readonly"
                                                :file-list="item.file"
                                                :name="'file'"
                                                :on-preview="handlePreview"
                                                :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'fire_products_file',scope.$index,index)}"
                                                :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'fire_products_file',scope.$index,index)}"
                                                multiple>
                                                <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件
                                                </el-button>
                                            </el-upload>

                                        </el-form-item>
                                    </div>
                                </div>
                                <el-form-item v-else
                                              :prop="'fire_products_file.' + scope.$index + '.file'"
                                              :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}" label-width="0">
                                    <el-upload
                                        :action="udhost + '/api/index/upload'"
                                        :data="fileData"
                                        :disabled="readonly"
                                        :file-list="scope.row.file"
                                        :name="'file'"
                                        :on-preview="handlePreview"
                                        :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'fire_products_file',scope.$index)}"
                                        :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'fire_products_file',scope.$index)}"
                                        multiple>
                                        <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件</el-button>
                                    </el-upload>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="建筑、消防施工等相关资质及证书：" prop="construction_construction">
                        <el-select
                            v-model="infoForm.construction_construction"
                            :disabled="readonly"
                            class="w-all" multiple
                            placeholder="请选择建筑、消防施工等相关资质及证书"
                            @change="(e)=>{return classifyChange(e,'construction_construction_file','zizhiList')}">
                            <el-option
                                v-for="item in zizhiList"
                                :key="item.value"
                                :disabled="(infoForm.construction_construction.indexOf(0) !== -1 && item.value !== 0)
                                    || (infoForm.construction_construction.filter(f=> {return f !==0 }).length > 0 && item.value === 0)"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-table
                        v-if="infoForm.construction_construction_file.filter(item=>{return item.id !== 0}).length > 0"
                        :data="infoForm.construction_construction_file.filter(item=>{return item.id !== 0})"
                        border
                        class="margin-bottom-sm"
                        style="width: 100%">
                        <el-table-column label="名称" prop="name" width="220">
                        </el-table-column>
                        <el-table-column label="附件">
                            <template slot-scope="scope">
                                <div v-if="scope.row.name.indexOf('其他') !== -1" class="flex flex-direction">
                                    <el-button v-if="!readonly" class="self-end" plain size="mini"
                                               type="primary"
                                               @click="addItem('construction_construction_file',scope.$index)">
                                        添加
                                    </el-button>
                                    <div v-for="(item,index) in scope.row.content" :key="index" class="other flex flex-direction">
                                        <el-form-item :prop="'construction_construction_file.' + scope.$index + '.content.'+ index + '.name'"
                                                      :rules="{required: true, message: '请输入其他描述', trigger: 'blur'}"
                                                      label-width="0">
                                            <div class="flex align-center justify-between">
                                                <el-input v-model="item.name" :disabled="readonly" placeholder="请输入其他描述" size="mini"></el-input>
                                                <el-button v-if="!readonly" class="margin-left" plain size="mini"
                                                           type="danger"
                                                           @click="delItem('construction_construction_file',scope.$index,index)">
                                                    删除
                                                </el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :prop="'construction_construction_file.' + scope.$index + '.content.'+ index + '.file'"
                                                      :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}"
                                                      label-width="0">
                                            <el-upload
                                                :action="udhost + '/api/index/upload'"
                                                :data="fileData"
                                                :disabled="readonly"
                                                :file-list="item.file"
                                                :name="'file'"
                                                :on-preview="handlePreview"
                                                :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'construction_construction_file',scope.$index,index)}"
                                                :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'construction_construction_file',scope.$index,index)}"
                                                multiple>
                                                <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件
                                                </el-button>
                                            </el-upload>

                                        </el-form-item>
                                    </div>
                                </div>
                                <el-form-item v-else
                                              :prop="'construction_construction_file.' + scope.$index + '.file'"
                                              :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}" label-width="0">
                                    <el-upload
                                        :action="udhost + '/api/index/upload'"
                                        :data="fileData"
                                        :disabled="readonly"
                                        :file-list="scope.row.file"
                                        :name="'file'"
                                        :on-preview="handlePreview"
                                        :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'construction_construction_file',scope.$index)}"
                                        :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'construction_construction_file',scope.$index)}"
                                        multiple>
                                        <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件</el-button>
                                    </el-upload>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>


                <el-col :span="24">
                    <el-form-item label="消防行业相关专利证书：" prop="patent_certificate.state">
                        <el-radio-group v-model="infoForm.patent_certificate.state" :disabled="readonly">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.patent_certificate.state === 1" :span="24">
                    <el-form-item label="消防行业相关专利证书说明：" prop="patent_certificate.content">
                        <el-input
                            v-model="infoForm.patent_certificate.content"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请输入消防行业相关专利证书说明"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.patent_certificate.state === 1" :span="24">
                    <el-form-item label="上传附件：" prop="patent_certificate.file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.patent_certificate.file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'patent_certificate',-2)}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'patent_certificate',-2)}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="政府有关部门认可的示范项目：" prop="government_projects.state">
                        <el-radio-group v-model="infoForm.government_projects.state" :disabled="readonly">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.government_projects.state === 1" :span="24">
                    <el-form-item label="政府有关部门认可的示范项目说明：" prop="government_projects.content">
                        <el-input
                            v-model="infoForm.government_projects.content"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请输入政府有关部门认可的示范项目说明"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.government_projects.state === 1" :span="24">
                    <el-form-item label="上传附件：" prop="government_projects.file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.government_projects.file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'government_projects',-2)}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'government_projects',-2)}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="消防相关行业协会认可的示范项目：" prop="association_project.state">
                        <el-radio-group v-model="infoForm.association_project.state" :disabled="readonly">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.association_project.state === 1" :span="24">
                    <el-form-item label="消防相关行业协会认可的示范项目说明：" prop="association_project.content">
                        <el-input
                            v-model="infoForm.association_project.content"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请输入消防相关行业协会认可的示范项目说明"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.association_project.state === 1" :span="24">
                    <el-form-item label="上传附件：" prop="association_project.file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.association_project.file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'association_project',-2)}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'association_project',-2)}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="获得过本行业相关认证：" prop="industry_certification.state">
                        <el-radio-group v-model="infoForm.industry_certification.state" :disabled="readonly">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.industry_certification.state === 1" :span="24">
                    <el-form-item label="获得过本行业相关认证说明：" prop="industry_certification.content">
                        <el-input
                            v-model="infoForm.industry_certification.content"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请输入获得过本行业相关认证说明"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.industry_certification.state === 1" :span="24">
                    <el-form-item label="上传附件：" prop="industry_certification.file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.industry_certification.file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'industry_certification',-2)}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'industry_certification',-2)}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="具有非上述类相关资质及证书：" prop="above_related.state">
                        <el-radio-group v-model="infoForm.above_related.state" :disabled="readonly">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.above_related.state === 1" :span="24">
                    <el-form-item label="具有非上述类相关资质及证书说明：" prop="above_related.content">
                        <el-input
                            v-model="infoForm.above_related.content"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请输入具有非上述类相关资质及证书说明"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.above_related.state === 1" :span="24">
                    <el-form-item label="上传附件：" prop="above_related.file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.above_related.file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'above_related',-2)}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'above_related',-2)}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <div class="flex align-center justify-between">
                        <div class="mune-title margin-top-sm">2.主营消防产品及特点</div>
                        <el-button v-if="!readonly" size="small" type="primary" @click="addFireProductsFeatures(false,-1)">
                            添加
                        </el-button>
                    </div>
                    <el-form-item label-width="0" prop="fire_products_features">
                        <el-table
                            :data="infoForm.fire_products_features"
                            border
                            class="margin-sm"
                            style="width: 100%">
                            <el-table-column label="产品类别" prop="type" width="320">
                                <template slot-scope="scope">
                                    {{ scope.row.type | fire_products_features_type }}
                                </template>
                            </el-table-column>
                            <el-table-column label="产品分类" prop="classify">
                                <template slot-scope="scope">
                                    {{ scope.row.classify | fire_products_features_classify(scope.row.type) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="典型产品名称" prop="classify">
                                <template slot-scope="scope">
                                    {{ scope.row.cate | fire_products_features_cate(scope.row.classify,scope.row.type) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="内容">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'fire_products_features.' + scope.$index + '.content'"
                                                  :rules="{required: true, message: '请输入描述', trigger: 'change'}" label-width="0">
                                        <el-input v-model="scope.row.content" :disabled="readonly" placeholder="请输入描述" size="mini"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="false" label="附件">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'fire_products_features.' + scope.$index + '.file'" :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}"
                                                  class="right-tip" label-width="0">
                                        <el-upload
                                            :action="udhost + '/api/index/upload'"
                                            :data="fileData"
                                            :disabled="readonly"
                                            :file-list="scope.row.file"
                                            :name="'file'"
                                            :on-preview="handlePreview"
                                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'fire_products_features',scope.$index)}"
                                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'fire_products_features',scope.$index)}"
                                            multiple>
                                            <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件
                                            </el-button>
                                        </el-upload>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="!readonly"
                                label="操作"
                                width="100">
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" @click="delFireProductsFeaturesItem(scope.$index)">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="flex align-center justify-between">
                        <div class="mune-title margin-top-sm">3.主营消防服务及特点</div>
                        <el-button v-if="!readonly" size="small" type="primary" @click="addFireServicesFeatures(false,-1)">
                            添加
                        </el-button>
                    </div>
                    <el-form-item label-width="0" prop="fire_services_features">
                        <el-table
                            :data="infoForm.fire_services_features"
                            border
                            class="margin-sm"
                            style="width: 100%">
                            <el-table-column label="产品分类" prop="type" width="420">
                                <template slot-scope="scope">
                                    {{ scope.row.type | fire_services_features_type }}
                                </template>
                            </el-table-column>
                            <el-table-column label="内容">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'fire_services_features.' + scope.$index + '.content'"
                                                  :rules="{required: true, message: '请输入描述', trigger: 'change'}" label-width="0">
                                        <el-input v-model="scope.row.content" :disabled="readonly" placeholder="请输入描述" size="mini"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="附件">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'fire_services_features.' + scope.$index + '.file'" :rules="{type: 'array', required: true, message: '请上传附件', trigger: 'change', min: 1}"
                                                  class="right-tip" label-width="0">
                                        <el-upload
                                            :action="udhost + '/api/index/upload'"
                                            :data="fileData"
                                            :disabled="readonly"
                                            :file-list="scope.row.file"
                                            :name="'file'"
                                            :on-preview="handlePreview"
                                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'fire_services_features',scope.$index)}"
                                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'fire_services_features',scope.$index)}"
                                            multiple>
                                            <el-button v-if="!readonly" plain size="mini" type="primary"> + 上传附件
                                            </el-button>
                                        </el-upload>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="!readonly"
                                label="操作"
                                width="100">
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" @click="delFireServicesFeaturesItem(scope.$index)">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>


                <el-col :span="24">
                    <div class="mune-title first">二、业绩信息</div>
                    <div class="mune-title margin-top-sm">1.业绩情况</div>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="近三年消防行业业务项目数量：" prop="management_number">
                        <div class="flex flex-direction">
                            <el-select
                                v-model="infoForm.management_number"
                                :disabled="readonly"
                                class="w-all" placeholder="请选择">
                                <el-option
                                    v-for="item in bigNumList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <div>注：包含消防技术服务、电气防火检测、排油烟设施清洗、消防设计与施工、消防宣传教育培训、消防信息化建设、消防产品等业务项目</div>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="近三年消防行业营业收入：" prop="business_income">
                        <el-select
                            v-model="infoForm.business_income"
                            :disabled="readonly"
                            class="w-all" placeholder="请选择">
                            <el-option
                                v-for="item in ysMoneyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="近三年政府购买服务项目：" prop="service_experience_number">
                        <div class="flex flex-direction">
                            <el-select
                                v-model="infoForm.service_experience_number"
                                :disabled="readonly"
                                class="w-all" placeholder="请选择">
                                <el-option
                                    v-for="item in serviceNumList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <div>注：为政府机关、事业单位等服务的项目数量</div>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="典型项目：" prop="exponent">
                        <el-radio-group v-model="infoForm.exponent" :disabled="readonly">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.exponent === 1" :span="24">
                    <el-form-item label="典型项目描述：" prop="exponent_desc">
                        <el-input
                            v-model="infoForm.exponent_desc"
                            :disable="readonly"
                            :rows="5"
                            placeholder="请输入例：参与冬奥会场馆、重大活动值守或维保"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.exponent === 1" :span="24">
                    <el-form-item label="上传附件：" prop="exponent_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.exponent_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'exponent_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'exponent_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="mune-title first">三、信用信息</div>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="总队信用评价：" prop="corps_credit">
                        <el-radio-group v-model="infoForm.corps_credit" :disabled="readonly">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.corps_credit === 1" :span="24">
                    <el-form-item label="总队信用评价描述：" prop="corps_credit_desc">
                        <el-input
                            v-model="infoForm.corps_credit_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请输入"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.corps_credit === 1" :span="24">
                    <el-form-item label="上传附件：" prop="corps_credit_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.corps_credit_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'corps_credit_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'corps_credit_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="协会信用评价：" prop="association_credit">
                        <el-radio-group v-model="infoForm.association_credit" disabled>
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                        <div>注：该信息由协会填写</div>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.association_credit === 1" :span="24">
                    <el-form-item label="协会信用评价描述：" prop="association_credit_desc">
                        <el-input
                            v-model="infoForm.association_credit_desc"
                            :rows="5"
                            disabled
                            placeholder="请输入"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.association_credit === 1" :span="24">
                    <el-form-item label="上传附件：" prop="association_credit_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :file-list="infoForm.association_credit_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'association_credit_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'association_credit_file')}"
                            disabled
                            multiple>
                            <!--                            <div class="flex align-center">-->
                            <!--                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>-->
                            <!--                            </div>-->
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="社会信用评价：" prop="association_credit">
                        <el-radio-group v-model="infoForm.social_credit" :disabled="readonly">
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.social_credit === 1" :span="24">
                    <el-form-item label="社会信用评价描述：" prop="social_credit_desc">
                        <el-input
                            v-model="infoForm.social_credit_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请输入"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.social_credit === 1" :span="24">
                    <el-form-item label="上传附件：" prop="social_credit_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.social_credit_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'social_credit_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'social_credit_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="信用评价事件：" prop="assessment">
                        <el-radio-group v-model="infoForm.assessment" disabled>
                            <el-radio :label="1">有</el-radio>
                            <el-radio :label="0">无</el-radio>
                        </el-radio-group>
                        <div>注：该信息由协会填写</div>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.assessment === 1" :span="24">
                    <el-form-item label="信用评价事件描述：" prop="assessment_desc">
                        <el-input
                            v-model="infoForm.assessment_desc"
                            :rows="5"
                            disabled
                            placeholder="请输入"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.assessment === 1" :span="24">
                    <el-form-item label="上传附件：" prop="assessment_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :file-list="infoForm.assessment_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'assessment_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'assessment_file')}"
                            disabled
                            multiple>
                            <!--                            <div class="flex align-center">-->
                            <!--                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>-->
                            <!--                                <p class="padding-left">备注：火灾事故倒查、舆情、举报投诉等</p>-->
                            <!--                            </div>-->
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <div class="mune-title first">四、贡献信息</div>
                    <div class="mune-title margin-top-sm">1.行业贡献信息</div>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="是否提出立法方面的意见和建议：" prop="is_legislation">
                        <el-radio-group v-model="infoForm.is_legislation" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_legislation === 1" :span="24">
                    <el-form-item label="立法方面的描述：" prop="legislation_desc">
                        <el-input
                            v-model="infoForm.legislation_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请描述向什么部门提供的什么建议"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_legislation === 1" :span="24">
                    <el-form-item label="上传附件：" prop="legislation_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.legislation_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'legislation_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'legislation_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="是否提出政策方面的意见和建议：" prop="is_policy">
                        <el-radio-group v-model="infoForm.is_policy" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_policy === 1" :span="24">
                    <el-form-item label="政策方面的描述：" prop="policy_desc">
                        <el-input
                            v-model="infoForm.policy_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请描述向什么部门提供的什么建议"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_policy === 1" :span="24">
                    <el-form-item label="上传附件：" prop="policy_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.policy_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'policy_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'policy_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="是否提出标准方面的意见和建议：" prop="is_standard">
                        <el-radio-group v-model="infoForm.is_standard" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_standard === 1" :span="24">
                    <el-form-item label="标准方面的描述：" prop="standard_desc">
                        <el-input
                            v-model="infoForm.standard_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请描述向什么部门提供的什么建议"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_standard === 1" :span="24">
                    <el-form-item label="上传附件：" prop="standard_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.standard_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'standard_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'standard_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="是否提出市场方面的意见和建议：" prop="is_market">
                        <el-radio-group v-model="infoForm.is_market" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_market === 1" :span="24">
                    <el-form-item label="市场方面的描述：" prop="market_desc">
                        <el-input
                            v-model="infoForm.market_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请描述向什么部门提供的什么建议"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_market === 1" :span="24">
                    <el-form-item label="上传附件：" prop="market_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.market_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'market_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'market_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="是否提出调研方面的意见和建议：" prop="is_investigation">
                        <el-radio-group v-model="infoForm.is_investigation" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_investigation === 1" :span="24">
                    <el-form-item label="调研方面的描述：" prop="investigation_desc">
                        <el-input
                            v-model="infoForm.investigation_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请描述向什么部门提供的什么建议"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.is_investigation === 1" :span="24">
                    <el-form-item label="上传附件：" prop="investigation_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.investigation_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'investigation_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'investigation_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="是否参与制定国标：" prop="standards">
                        <el-radio-group v-model="infoForm.standards" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.standards === 1" :span="24">
                    <el-form-item label="标准名称：" prop="standards_desc">
                        <el-input
                            v-model="infoForm.standards_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请填写标准名称"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.standards === 1" :span="24">
                    <el-form-item label="上传附件：" prop="standards_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.standards_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'standards_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'standards_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="是否参与制定地标：" prop="landmarks">
                        <el-radio-group v-model="infoForm.landmarks" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.landmarks === 1" :span="24">
                    <el-form-item label="标准名称：" prop="landmarks_desc">
                        <el-input
                            v-model="infoForm.landmarks_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请填写标准名称"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.landmarks" :span="24">
                    <el-form-item label="上传附件：" prop="landmarks_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.landmarks_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'landmarks_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'landmarks_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="是否参与制定团标：" prop="make_group">
                        <el-radio-group v-model="infoForm.make_group" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.make_group === 1" :span="24">
                    <el-form-item label="标准名称：" prop="make_group_desc">
                        <el-input
                            v-model="infoForm.make_group_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请填写标准名称"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.make_group === 1" :span="24">
                    <el-form-item label="上传附件：" prop="make_group_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.make_group_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'make_group_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'make_group_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="是否参与制定协会行业服务标准：" prop="association_association">
                        <el-radio-group v-model="infoForm.association_association" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.association_association === 1" :span="24">
                    <el-form-item label="标准名称：" prop="association_association_desc">
                        <el-input
                            v-model="infoForm.association_association_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请填写标准名称"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.association_association === 1" :span="24">
                    <el-form-item label="上传附件：" prop="association_association_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.association_association_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'association_association_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'association_association_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="是否参与质量现场核查工作：" prop="scene_check">
                        <el-radio-group v-model="infoForm.scene_check" :disabled="readonly">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                        <!--                        <div>注：参加协会组织的服务质量现场核查</div>-->
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.scene_check === 1" :span="24">
                    <el-form-item label="核查工作描述：" prop="scene_check_desc">
                        <el-input
                            v-model="infoForm.scene_check_desc"
                            :disabled="readonly"
                            :rows="5"
                            placeholder="请描述什么时间、什么地点，参与过什么核查"
                            type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.scene_check === 1" :span="24">
                    <el-form-item label="上传附件：" prop="scene_check_file">
                        <el-upload
                            :action="udhost + '/api/index/upload'"
                            :data="fileData"
                            :disabled="readonly"
                            :file-list="infoForm.scene_check_file"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-remove="(file,fileList)=>{return handleRemove(file,fileList,'scene_check_file')}"
                            :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,'scene_check_file')}"
                            multiple>
                            <div class="flex align-center">
                                <el-button v-if="!readonly" plain type="primary"> + 上传附件</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-row :span="20">
                        <el-col :span="16">
                            <el-form-item label="宣传协会频次(上自然年度)：" prop="propaganda_last">
                                <el-radio-group v-model="infoForm.propaganda_last" :disabled="readonly">
                                    <el-radio :label="1">有</el-radio>
                                    <el-radio :label="0">无</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="infoForm.propaganda_last === 1" :span="8">
                            <el-form-item label-width="0" prop="propaganda_last_num">
                                <el-input
                                    v-model="infoForm.propaganda_last_num"
                                    :disabled="readonly" placeholder="请输入">
                                    <template slot="append">次</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row :span="20">
                        <el-col :span="16">
                            <el-form-item label="宣传协会频次(本自然年度)：" prop="propaganda_this">
                                <el-radio-group v-model="infoForm.propaganda_this" :disabled="readonly">
                                    <el-radio :label="1">有</el-radio>
                                    <el-radio :label="0">无</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="infoForm.propaganda_this === 1" :span="8">
                            <el-form-item label-width="0" prop="propaganda_this_num">
                                <el-input
                                    v-model="infoForm.propaganda_this_num"
                                    :disabled="readonly" placeholder="请输入">
                                    <template slot="append">次</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :span="12">
                    <el-row :span="24">
                        <el-col :span="16">
                            <el-form-item label="发展会员数量(上自然年度)：" prop="recommend_last">
                                <el-radio-group v-model="infoForm.recommend_last" :disabled="readonly">
                                    <el-radio :label="1">有</el-radio>
                                    <el-radio :label="0">无</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="infoForm.recommend_last === 1" :span="8">
                            <el-form-item label-width="0" prop="recommend_last_num">
                                <el-input
                                    v-model="infoForm.recommend_last_num"
                                    :disabled="readonly" placeholder="请输入">
                                    <template slot="append">个</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row :span="24">
                        <el-col :span="16">
                            <el-form-item label="发展会员数量(本自然年度)：" prop="recommend_this">
                                <el-radio-group v-model="infoForm.recommend_this" :disabled="readonly">
                                    <el-radio :label="1">有</el-radio>
                                    <el-radio :label="0">无</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="infoForm.recommend_this === 1" :span="8">
                            <el-form-item label-width="0" prop="recommend_this_num">
                                <el-input
                                    v-model="infoForm.recommend_this_num"
                                    :disabled="readonly" placeholder="请输入">
                                    <template slot="append">个</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :span="12">
                    <el-row :span="24">
                        <el-col :span="16">
                            <el-form-item label="联系会员频次(上自然年度)：" prop="contact_member_last">
                                <el-radio-group v-model="infoForm.contact_member_last" :disabled="readonly">
                                    <el-radio :label="1">有</el-radio>
                                    <el-radio :label="0">无</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="infoForm.contact_member_last === 1" :span="8">
                            <el-form-item label-width="0" prop="contact_member_last_num">
                                <el-input
                                    v-model="infoForm.contact_member_last_num"
                                    :disabled="readonly" placeholder="请输入">
                                    <template slot="append">次</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row :span="24">
                        <el-col :span="16">
                            <el-form-item label="联系会员频次(本自然年度)：" prop="contact_member_this">
                                <el-radio-group v-model="infoForm.contact_member_this" :disabled="readonly">
                                    <el-radio :label="1">有</el-radio>
                                    <el-radio :label="0">无</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="infoForm.contact_member_this === 1" :span="8">
                            <el-form-item label-width="0" prop="contact_member_this_num">
                                <el-input
                                    v-model="infoForm.contact_member_this_num"
                                    :disabled="readonly" placeholder="请输入">
                                    <template slot="append">次</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="24">
                    <div class="mune-title first">五.关联信息</div>
                    <div class="mune-title margin-top-sm">1.联系会员单位</div>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联络人：" prop="contact_person">
                        <el-input
                            v-model="infoForm.contact_person"
                            :disabled="readonly" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联络电话：" prop="contact_phone">
                        <el-input
                            v-model="infoForm.contact_phone"
                            :disabled="readonly" placeholder="请输入">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="被联系的上家会员单位" prop="higher_level">
                        <el-select
                            v-model="infoForm.higher_level"
                            :disabled="readonly"
                            class="w-all" clearable filterable placeholder="请选择" @change="higherLevelChange">
                            <el-option
                                v-for="item in oneLevelLabels.filter(f=>{
                                    return f.level < 3 && f.level
                                })"
                                :key="item.id"
                                :label="item.company_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="0" prop="interactive_information">
                        <el-table
                            :data="infoForm.higher_level ? [infoForm.higher_level_info] : []"
                            border
                            class="margin-sm"
                            style="width: 100%">
                            <el-table-column label="单位名称" prop="name">
                                <template slot-scope="scope">
                                    {{ scope.row.company_name }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="联络员">
                                <template slot-scope="scope">
                                    {{ scope.row.contact_person }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="联络电话">
                                <template slot-scope="scope">
                                    {{ scope.row.contact_phone }}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
                <el-col v-if="infoForm.higher_level" :span="24">
                    <el-form-item label="联系的下家会员单位" prop="lower_level">
                        <el-select
                            v-model="infoForm.lower_level"
                            :disabled="readonly"
                            class="w-all" filterable multiple placeholder="请选择" @change="lowerLevelChange">
                            <el-option
                                v-for="item in oneLevelLabels.filter(f=>{
                                   return f.level == 3 || !f.level
                                })"
                                :key="item.id"
                                :label="item.company_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="flex flex-direction">
                        <el-form-item label-width="0" prop="interactive_information">
                            <el-table
                                :data="infoForm.lower_level_info"
                                border
                                class="margin-sm"
                                style="width: 100%">
                                <el-table-column label="单位名称" prop="name">
                                    <template slot-scope="scope">
                                        {{ scope.row.company_name }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="会员证书到期时间" prop="valid_time_end_time">
                                    <template slot-scope="scope">
                                        {{ scope.row.valid_time_end_time || '--' }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="联络员">
                                    <template slot-scope="scope">
                                        {{ scope.row.contact_person }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="联络电话">
                                    <template slot-scope="scope">
                                        {{ scope.row.contact_phone }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                        <el-button
                            class="self-center"
                            size="small"
                            type="primary"
                            @click="exportExcel"
                        >导出
                        </el-button>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="flex align-center justify-between">
                        <div class="mune-title margin-top-sm">2.介绍会员单位入会</div>
                        <el-button v-if="!readonly" size="small" type="primary" @click="addIntroduction(false,-1)">添加
                        </el-button>
                    </div>
                    <el-form-item label-width="0" prop="interactive_information">
                        <el-table
                            :data="infoForm.introduction_unit_ids"
                            border
                            class="margin-sm"
                            style="width: 100%">
                            <el-table-column label="单位名称" prop="name">
                                <template slot-scope="scope">
                                    <router-link :to="`/home/memberDetail/${scope.row}`" target="_blank">
                                        {{ scope.row | introduction_unit(introductionLabels) }}
                                    </router-link>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-if="!readonly"
                                label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" @click="delIntroduction(scope.$index)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="flex align-center justify-between">
                        <div class="mune-title margin-top-sm">3.与协会互动信息</div>
                        <el-button v-if="!readonly" size="small" type="primary" @click="addInteractive(false,-1)">添加
                        </el-button>
                    </div>
                    <el-form-item label-width="0" prop="interactive_information">
                        <el-table
                            :data="infoForm.interactive_information"
                            border
                            class="margin-sm"
                            style="width: 100%">
                            <el-table-column label="标题" prop="title" width="220">
                            </el-table-column>
                            <el-table-column label="标签" prop="label" width="200">
                                <template slot-scope="scope">
                                    {{ scope.row.label | interactive_label(informationLabels) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="内容" prop="content">
                            </el-table-column>
                            <el-table-column label="时间" prop="time" width="120">
                            </el-table-column>
                            <el-table-column
                                v-if="!readonly"
                                label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" @click="addInteractive(scope.row,scope.$index)">
                                        编辑
                                    </el-button>
                                    <el-button size="small" type="text" @click="delInteractive(scope.$index)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <div class="flex align-center justify-between">
                        <div class="mune-title margin-top-sm">4.合作会员单位</div>
                        <el-button v-if="!readonly" size="small" type="primary" @click="addRelated(false,-1)">添加
                        </el-button>
                    </div>
                    <el-form-item label-width="0" prop="related_information">
                        <el-table
                            :data="infoForm.related_information"
                            border
                            class="margin-sm"
                            style="width: 100%">
                            <el-table-column label="合作单位" prop="post" width="200">
                                <template slot-scope="scope">
                                    {{ scope.row.post | related_label(relatedLabels) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="关联内容" prop="content">
                            </el-table-column>
                            <el-table-column label="关联时间" prop="time" width="120">
                            </el-table-column>
                            <el-table-column
                                v-if="!readonly"
                                label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" @click="addRelated(scope.row,scope.$index)">编辑
                                    </el-button>
                                    <el-button size="small" type="text" @click="delRelated(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
                <el-col v-if="!readonly" :span="24">
                    <el-form-item label-width="0">
                        <div class="flex align-center justify-center">
                            <el-button v-if="state === 0" class="w-20 margin-right" plain
                                       type="primary" @click="submitForm('infoForm',0)">保存
                            </el-button>
                            <el-button class="w-20" type="primary"
                                       @click="submitForm('infoForm',1)">{{ state === 0 ? '' : '修改' }}提交
                            </el-button>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="mune-title first">六、抽查</div>
                </el-col>
                <el-col :span="24">
                    <div class="flex align-center margin-top-sm">
                        <div class="mune-title ">1.抽查记录</div>
                        <div class="margin-left-sm">注：该信息由协会填写</div>
                    </div>
                    <div class="flex flex-direction">
                        <el-table
                            :data="log_tableData"
                            border
                            class="margin-sm"
                            style="width: 100%">
                            <el-table-column label="抽查内容" prop="content">
                            </el-table-column>
                            <el-table-column label="抽查时间" prop="check_time" width="200">
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            v-if="log_tableData.length > 0"
                            :current-page.sync="log_page"
                            :page-size="limit"
                            :total="log_total"
                            background
                            class="self-end margin-bottom-sm"
                            layout="prev, pager, next, jumper"
                            @current-change="getCheckLogList"
                        >
                        </el-pagination>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="mune-title first">七、反馈</div>
                </el-col>
                <el-col :span="24">
                    <div class="flex align-center justify-between margin-top-sm">
                        <div class="mune-title ">1.信息反馈</div>
                        <el-button size="small" type="primary" @click="addFeedback(false,-1)">添加</el-button>
                    </div>
                    <div class="flex flex-direction">
                        <el-table
                            :data="feedback_tableData"
                            border
                            class="margin-sm"
                            style="width: 100%">
                            <el-table-column label="反馈内容" prop="content">
                            </el-table-column>
                            <el-table-column label="反馈时间" prop="create_time" width="200">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                width="100">
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" @click="addFeedback(scope.row,scope.row.id)">编辑
                                    </el-button>
                                    <el-button size="small" type="text" @click="delFeedback(scope.row.id)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            v-if="feedback_tableData.length > 0"
                            :current-page.sync="feedback_page"
                            :page-size="limit"
                            :total="feedback_total"
                            background
                            class="self-end margin-bottom-sm"
                            layout="prev, pager, next, jumper"
                            @current-change="getFeedBackList">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
        </el-form>

        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :visible.sync="showFireProductsFeaturesDialog"
            center
            title="主营消防产品及特点"
            width="680px">
            <el-form ref="ruleFireProductsFeaturesForm" :model="ruleFireProductsFeaturesForm" :rules="fireProductsFeaturesRules" label-width="auto">
                <el-form-item label="产品分类" prop="type">
                    <el-cascader v-model="ruleFireProductsFeaturesForm.type" :options="productList" filterable style="width: 100%"></el-cascader>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm()">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitFireProductsFeaturesForm('ruleFireProductsFeaturesForm')">
                        提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :visible.sync="showFireServicesFeaturesDialog"
            center
            title="主营消防服务及特点"
            width="480px">
            <el-form ref="ruleFireServicesFeaturesForm" :model="ruleFireServicesFeaturesForm" :rules="fireServicesFeaturesRules" label-width="auto">
                <el-form-item label="产品分类" prop="type">
                    <el-select
                        v-model="ruleFireServicesFeaturesForm.type"
                        class="w-all"
                        filterable placeholder="请选择">
                        <el-option
                            v-for="item in supply"
                            :key="item.value"
                            :disabled="item.disabled"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm()">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitFireServicesFeaturesForm('ruleFireServicesFeaturesForm')">
                        提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :visible.sync="showIntroductionDialog"
            center
            title="介绍会员单位入会"
            width="480px">
            <el-form ref="ruleIntroductionForm" :model="ruleIntroductionForm" :rules="introductionRules" label-width="auto">
                <el-form-item label="会员单位" prop="type">
                    <el-select
                        v-model="ruleIntroductionForm.id"
                        class="w-all"
                        filterable placeholder="请选择">
                        <el-option
                            v-for="item in introductionLabels"
                            :key="item.user_id"
                            :disabled="item.is_selected === 0"
                            :label="item.company_name"
                            :value="item.user_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm()">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitIntroductionForm('ruleIntroductionForm')">
                        提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :visible.sync="showInteractiveDialog"
            center
            title="与协会互动信息"
            width="480px">
            <el-form ref="ruleInteractiveForm" :model="ruleInteractiveForm" :rules="interactiveRules" label-width="auto">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="ruleInteractiveForm.title" placeholder="请输入标题">
                    </el-input>
                </el-form-item>
                <el-form-item label="标签" prop="label">
                    <el-select
                        v-model="ruleInteractiveForm.label"
                        class="w-all"
                        placeholder="请选择">
                        <el-option
                            v-for="item in informationLabels"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间" prop="time">
                    <el-date-picker
                        v-model="ruleInteractiveForm.time"
                        placeholder="请选择时间"
                        style="width: 100%"
                        type="date"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-input v-model="ruleInteractiveForm.content" :rows="5" placeholder="请输入内容" type="textarea"></el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm()">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitInteractiveForm('ruleInteractiveForm')">
                        提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :visible.sync="showRelatedDialog"
            center
            title="合作会员单位"
            width="480px">
            <el-form ref="ruleRelatedForm" :model="ruleRelatedForm" :rules="relatedRules" label-width="auto">
                <el-form-item label="合作单位" prop="post">
                    <el-select
                        v-model="ruleRelatedForm.post"
                        class="w-all"
                        filterable
                        placeholder="请选择">
                        <el-option
                            v-for="item in relatedLabels"
                            :key="item.user_id"
                            :label="item.company_name"
                            :value="item.user_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关联时间" prop="time">
                    <el-date-picker
                        v-model="ruleRelatedForm.time"
                        placeholder="请选择关联时间"
                        style="width: 100%"
                        type="date"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="关联内容" prop="content">
                    <el-input v-model="ruleRelatedForm.content" :rows="5" placeholder="请输入关联内容" type="textarea"></el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm()">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitRelatedForm('ruleRelatedForm')">提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :visible.sync="showContentDialog"
            center
            title="信息反馈"
            width="480px">
            <el-form ref="ruleContentForm" :model="ruleContentForm" :rules="contentRules" label-width="auto">
                <el-form-item label="反馈内容" prop="content">
                    <el-input v-model="ruleContentForm.content" :rows="5" placeholder="请输入内容" type="textarea"></el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" @click="resetForm()">取消</el-button>
                    <el-button class="padding-lr-xl" type="primary" @click="submitContentForm('ruleContentForm')">提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {
    _reduce,
    bigNumList,
    creditLevelList,
    educationTrainingList,
    fireProductList, getToken,
    informationQualificationList,
    jYearList,
    lampblackList,
    moneyList,
    optionList,
    productList,
    serviceList,
    serviceNumList,
    sheBaoNumberList,
    supply,
    vipNumList,
    vipYearList,
    ysMoneyList,
    zizhiList,
} from "@/utils/utils";
import {SHOWHOST, UDHOST} from '@/config/index'
import {
    addCredit,
    addFeedback,
    delFeedback,
    getCheckLogList,
    getCompany,
    getCreditInformation,
    getFeedBackList,
    getInformationLabel,
    getOneLevelCompany,
    getTruecompany
} from "@/api/member";

export default {
    name: "info",
    data() {
        return {
            id: '',
            moneyList: optionList(false, moneyList),
            jYearList: optionList(false, jYearList),
            serviceList: optionList(false, serviceList),
            informationQualificationList: optionList(false, informationQualificationList),
            educationTrainingList: optionList(false, educationTrainingList),
            lampblackList: optionList(false, lampblackList),
            fireProductList: optionList(false, fireProductList),
            zizhiList: optionList(false, zizhiList),
            sheBaoNumberList: optionList(false, sheBaoNumberList),
            vipYearList: optionList(false, vipYearList),
            bigNumList: optionList(false, bigNumList),
            ysMoneyList: optionList(false, ysMoneyList),
            serviceNumList: optionList(false, serviceNumList),
            vipNumList: optionList(false, vipNumList),
            creditLevelList: optionList(false, creditLevelList),
            productList: optionList(false, productList),
            supply: optionList(false, supply),
            infoForm: {
                register_capital: '',
                register_years: '',
                social_security_number: '',
                member_years: '',
                practice_condition: [],
                practice_condition_file: [],
                information_qualification: [],
                information_qualification_file: [],
                education_and_training: [],
                education_and_training_file: [],
                lampblack: [],
                lampblack_file: [],
                fire_products: [],
                fire_products_file: [],
                construction_construction: [],
                construction_construction_file: [],
                patent_certificate: {state: 0, content: '', file: []},
                government_projects: {state: 0, content: '', file: []},
                association_project: {state: 0, content: '', file: []},
                industry_certification: {state: 0, content: '', file: []},
                above_related: {state: 0, content: '', file: []},
                fire_products_features: [],
                fire_services_features: [],
                management_number: '',
                business_income: '',
                service_experience_number: '',
                exponent: 0,
                exponent_desc: '',
                exponent_file: [],
                corps_credit: 0,
                corps_credit_desc: '',
                corps_credit_file: [],
                association_credit: 0,
                association_credit_desc: '',
                association_credit_file: [],
                social_credit: 0,
                social_credit_desc: '',
                social_credit_file: [],
                assessment: 0,
                assessment_desc: '',
                assessment_file: [],
                is_legislation: 0,//	0	Text	是立法方面建议 0否 1是
                legislation_desc: '',
                legislation_file: [],//	-	Text	是立法方面文件
                is_policy: 0,//	1	Text	是政策方面建议 0否 1是
                policy_desc: '',
                policy_file: [],//	-	Text	是政策方面文件
                is_standard: 0,//	0	Text	是标准方面建议 0否 1是
                standard_desc: '',
                standard_file: [],//	-	Text	是标准方面文件
                is_market: 0,//	1	Text	是市场方面建议 0否 1是
                market_desc: '',
                market_file: [],//	-	Text	是市场方面附件
                is_investigation: 0,//	0	Text	是调研方面建议 0否 1是
                investigation_desc: '',
                investigation_file: [],//	-	Text	是调研方面附件
                standards: 0,
                standards_desc: '',
                standards_file: [],
                landmarks: 0,
                landmarks_desc: '',
                landmarks_file: [],
                make_group: 0,
                make_group_desc: '',
                make_group_file: [],
                association_association: 0,
                association_association_desc: '',
                association_association_file: [],
                scene_check: 0,
                scene_check_desc: '',
                scene_check_file: [],
                propaganda_last: 0, // '宣传协会频次 去年 0无 1有'
                propaganda_last_num: '', // '宣传协会频次 去年次数'
                propaganda_this: 0, // '宣传协会频次 本年 0无 1有'
                propaganda_this_num: '', // '宣传协会频次 本年次数'
                recommend_last: 0, // '发展会员数量 去年 0无 1有'
                recommend_last_num: '', // '发展会员数量 去年数量'
                recommend_this: 0, // '发展会员数量 本年 0无 1有'
                recommend_this_num: '', // '发展会员数量 本年数量'
                contact_member_last: 0, // '联系会员频次 去年 0无 1有'
                contact_member_last_num: '', // '联系会员频次 去年次数'
                contact_member_this: 0, // '联系会员频次 本年 0无 1有'
                contact_member_this_num: '', // '联系会员频次 本年次数'
                contact_person: '',
                contact_phone: '',
                higher_level: '',
                higher_level_info: {},
                lower_level: [],
                lower_level_info: [],
                introduction_unit_ids: [],
                interactive_information: [],
                related_information: [],
            },
            rules: {
                register_capital: [{required: true, message: '请选择注册资本', trigger: 'change'}],
                register_years: [{required: true, message: '请选择连续经营年限', trigger: 'change'}],
                social_security_number: [{required: true, message: '请选择社保员工人数', trigger: 'change'}],
                member_years: [{required: true, message: '请选择会员年限', trigger: 'change'}],
                practice_condition: [{required: true, message: '请选择消防技术服务从业条件', trigger: 'change'}],
                information_qualification: [{required: true, message: '请选择信息类相关资质及证书', trigger: 'change'}],
                education_and_training: [{required: true, message: '请选择教育培训类相关资质及证书', trigger: 'change'}],
                lampblack: [{required: true, message: '请选择排油烟大气环保相关资质及证书', trigger: 'change'}],
                fire_products: [{required: true, message: '请选择消防产品相关资质及证书', trigger: 'change'}],
                construction_construction: [{required: true, message: '请选择建筑、消防施工等相关资质及证书', trigger: 'change'}],
                'patent_certificate.content': [{required: true, message: '请输入消防行业相关专利证书说明', trigger: 'change'}],
                'patent_certificate.file': [{required: true, message: '请上传消防行业相关专利证书附件', trigger: 'change'}],
                'government_projects.content': [{required: true, message: '请输入政府有关部门认可的示范项目说明', trigger: 'change'}],
                'government_projects.file': [{required: true, message: '请上传政府有关部门认可的示范项目附件', trigger: 'change'}],
                'association_project.content': [{required: true, message: '请输入消防相关行业协会认可的示范项目说明', trigger: 'change'}],
                'association_project.file': [{required: true, message: '请上传消防相关行业协会认可的示范项目附件', trigger: 'change'}],
                'industry_certification.content': [{required: true, message: '请输入获得过本行业相关认证说明', trigger: 'change'}],
                'industry_certification.file': [{required: true, message: '请上传获得过本行业相关认证附件', trigger: 'change'}],
                'above_related.content': [{required: true, message: '请输入非上述类相关资质及证书说明', trigger: 'change'}],
                'above_related.file': [{required: true, message: '请上传非上述类相关资质及证书附件', trigger: 'change'}],
                fire_products_features: [{required: true, message: '请添加主营消防产品及特点', trigger: 'change'}],
                fire_services_features: [{required: true, message: '请添加主营消防服务及特点', trigger: 'change'}],
                management_number: [{required: true, message: '请选择近三年消防行业业务项目数量', trigger: 'change'}],
                business_income: [{required: true, message: '请选择近三年消防行业营业收入', trigger: 'blur'}],
                service_experience_number: [{required: true, message: '请选择近三年政府购买服务项目', trigger: 'change'}],
                exponent_desc: [{required: true, message: '请输入典型项目描述', trigger: 'blur'}],
                exponent_file: [{required: true, message: '请上传典型项目附件', trigger: 'blur'}],
                corps_credit_desc: [{required: true, message: '请输入总队信用评价描述', trigger: 'blur'}],
                corps_credit_file: [{required: true, message: '请上传总队信用评价附件', trigger: 'blur'}],
                association_credit_desc: [{required: true, message: '请输入协会信用评价描述', trigger: 'blur'}],
                association_credit_file: [{required: true, message: '请上传协会信用评价附件', trigger: 'blur'}],
                social_credit_desc: [{required: true, message: '请输入社会信用评价描述', trigger: 'blur'}],
                social_credit_file: [{required: true, message: '请上传社会信用评价附件', trigger: 'blur'}],
                assessment_desc: [{required: true, message: '请输入信用评价事件描述', trigger: 'blur'}],
                assessment_file: [{required: true, message: '请上传社会信用评价机构的评估报告附件', trigger: 'change'}],
                legislation_desc: [{required: true, message: '请输入立法方面描述', trigger: 'change'}],
                legislation_file: [{required: true, message: '请上传立法方面的意见和建议附件', trigger: 'change'}],
                policy_desc: [{required: true, message: '请输入政策方面描述', trigger: 'change'}],
                policy_file: [{required: true, message: '请上传政策方面的意见和建议附件', trigger: 'change'}],
                standard_desc: [{required: true, message: '请输入标准方面描述', trigger: 'change'}],
                standard_file: [{required: true, message: '请上传标准方面的意见和建议附件', trigger: 'change'}],
                market_desc: [{required: true, message: '请输入市场方面描述', trigger: 'change'}],
                market_file: [{required: true, message: '请上传市场方面的意见和建议附件', trigger: 'change'}],
                investigation_desc: [{required: true, message: '请输入调研方面描述', trigger: 'change'}],
                investigation_file: [{required: true, message: '请上传调研方面的意见和建议附件', trigger: 'change'}],
                standards_desc: [{required: true, message: '请输入国标标准名称', trigger: 'change'}],
                standards_file: [{required: true, message: '请上传参与制定国标附件', trigger: 'change'}],
                landmarks_desc: [{required: true, message: '请输入地标标准名称', trigger: 'change'}],
                landmarks_file: [{required: true, message: '请上传参与制定地标附件', trigger: 'change'}],
                make_group_desc: [{required: true, message: '请输入团标标准名称', trigger: 'change'}],
                make_group_file: [{required: true, message: '请上传参与制定团标附件', trigger: 'change'}],
                association_association_desc: [{required: true, message: '请输入协会行业服务标准名称', trigger: 'change'}],
                association_association_file: [{required: true, message: '请上传参与制定协会行业服务附件', trigger: 'change'}],
                scene_check_desc: [{required: true, message: '请描述什么时间、什么地点，参与过什么核查', trigger: 'change'}],
                scene_check_file: [{required: true, message: '请上传参与质量现场核查工作附件', trigger: 'change'}],
                propaganda_last_num: [{required: true, message: '请输入上自然年度宣传协会频次', trigger: 'change'}],
                propaganda_this_num: [{required: true, message: '请输入本自然年度宣传协会频次', trigger: 'change'}],
                recommend_last_num: [{required: true, message: '请输入上自然年度发展会员数量', trigger: 'change'}],
                recommend_this_num: [{required: true, message: '请输入本自然年度发展会员数量', trigger: 'change'}],
                contact_member_last_num: [{required: true, message: '请输入上自然年度联系会员频次', trigger: 'change'}],
                contact_member_this_num: [{required: true, message: '请输入本自然年度联系会员频次', trigger: 'change'}],
                contact_person: [{required: true, message: '请输入联络人', trigger: 'change'}],
                contact_phone: [{required: true, message: '请输入联络电话', trigger: 'change'}],
                // higher_level: [{required: true, message: '请选择被联系的上家会员单位', trigger: 'change'}],
                // lower_level: [{required: true, message: '请选择联系的下家会员单位', trigger: 'change'}],
                // introduction_unit_ids: [{required: true, message: '请选择介绍会员单位入会', trigger: 'change'}],
                // interactive_information: [{required: true, message: '请添加互动信息', trigger: 'change'}],
                // related_information: [{required: true, message: '请添加合作会员单位', trigger: 'change'}],
            },

            cur_index: -1,

            showFireProductsFeaturesDialog: false,
            ruleFireProductsFeaturesForm: {
                type: [],
            },
            fireProductsFeaturesRules: {
                type: [{required: true, message: '请选择分类', trigger: 'blur'}],
            },
            showFireServicesFeaturesDialog: false,
            ruleFireServicesFeaturesForm: {
                type: '',
            },
            fireServicesFeaturesRules: {
                type: [{required: true, message: '请选择分类', trigger: 'blur'}],
            },
            showIntroductionDialog: false,
            introductionLabels: [],
            ruleIntroductionForm: {
                id: '',
            },
            introductionRules: {
                id: [{required: true, message: '请选择单位', trigger: 'blur'}],
            },
            showInteractiveDialog: false,
            informationLabels: [],
            ruleInteractiveForm: {
                title: '',
                label: '',
                time: '',
                content: '',
            },
            interactiveRules: {
                title: [{required: true, message: '请输入标题', trigger: 'blur'}],
                label: [{required: true, message: '请选择标签', trigger: 'change'}],
                time: [{required: true, message: '请选择时间', trigger: 'blur'}],
                content: [{required: true, message: '请输入内容', trigger: 'blur'}],
            },
            showRelatedDialog: false,
            relatedLabels: [],
            ruleRelatedForm: {
                post: '',
                time: '',
                content: '',
            },
            relatedRules: {
                post: [{required: true, message: '请选择合作单位', trigger: 'change'}],
                time: [{required: true, message: '请选择关联时间', trigger: 'blur'}],
                content: [{required: true, message: '请输入关联内容', trigger: 'blur'}],
            },
            oneLevelLabels: [],

            readonly: true,
            state: 0,
            limit: 5,

            log_page: 1,
            log_total: 0,
            log_tableData: [],
            feedback_page: 1,
            feedback_total: 0,
            feedback_tableData: [],
            showContentDialog: false,
            ruleContentForm: {
                content: '',
            },
            contentRules: {
                content: [{required: true, message: '请输入内容', trigger: 'blur'}],
            },
            season: ''
        }
    },
    computed: {
        udhost() {
            return UDHOST
        },
        showhost() {
            return SHOWHOST
        },
        fileData() {
            return {
                // token: this.user.token
            };
        },
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "综合信息  / ", false, 'icon-jibenxinxi1');
        this.getDetail()
        this.getCheckLogList()
        this.getFeedBackList()
    },
    components: {},
    methods: {
        //  获取基本信息
        async getDetail() {
            let _data = await getInformationLabel()
            this.informationLabels = _data.data
            _data = await getCompany()
            this.relatedLabels = _data.data
            _data = await getTruecompany()
            this.introductionLabels = _data.data
            _data = await getOneLevelCompany()
            this.oneLevelLabels = _data.data
            _data = await getCreditInformation()
            if (_data.data) {
                this.state = _data.data.state || 0
                this.readonly = _data.data.state === 1
                this.id = _data.data.id
                this.season = _data.data.season

                let practice_condition = _data.data.practice_condition ? JSON.parse(_data.data.practice_condition) : [];
                let information_qualification = _data.data.information_qualification ? JSON.parse(_data.data.information_qualification) : [];
                let education_and_training = _data.data.education_and_training ? JSON.parse(_data.data.education_and_training) : [];
                let lampblack = _data.data.lampblack ? JSON.parse(_data.data.lampblack) : [];
                let fire_products = _data.data.lampblack ? JSON.parse(_data.data.fire_products) : [];
                let construction_construction = _data.data.construction_construction ? JSON.parse(_data.data.construction_construction) : [];
                let lower_level = _data.data.lower_level ? _data.data.lower_level.split(',').map(item => {
                    return Number(item)
                }) : [];
                this.infoForm = {
                    register_capital: _data.data.register_capital,
                    register_years: _data.data.register_years,
                    social_security_number: _data.data.social_security_number,
                    member_years: _data.data.member_years,
                    practice_condition: practice_condition.map(item => {
                        return item.id
                    }),
                    practice_condition_file: practice_condition,
                    information_qualification: information_qualification.map(item => {
                        return item.id
                    }),
                    information_qualification_file: information_qualification,
                    education_and_training: education_and_training.map(item => {
                        return item.id
                    }),
                    education_and_training_file: education_and_training,
                    lampblack: lampblack.map(item => {
                        return item.id
                    }),
                    lampblack_file: lampblack,
                    fire_products: fire_products.map(item => {
                        return item.id
                    }),
                    fire_products_file: fire_products,
                    construction_construction: construction_construction.map(item => {
                        return item.id
                    }),
                    construction_construction_file: construction_construction,
                    patent_certificate: _data.data.patent_certificate ? JSON.parse(_data.data.patent_certificate) : this.infoForm.patent_certificate,
                    government_projects: _data.data.government_projects ? JSON.parse(_data.data.government_projects) : this.infoForm.government_projects,
                    association_project: _data.data.association_project ? JSON.parse(_data.data.association_project) : this.infoForm.association_project,
                    industry_certification: _data.data.industry_certification ? JSON.parse(_data.data.industry_certification) : this.infoForm.industry_certification,
                    above_related: _data.data.above_related ? JSON.parse(_data.data.above_related) : this.infoForm.above_related,
                    fire_products_features: _data.data.fire_products_features ? JSON.parse(_data.data.fire_products_features) : [],
                    fire_services_features: _data.data.fire_services_features ? JSON.parse(_data.data.fire_services_features) : [],
                    management_number: _data.data.management_number,
                    business_income: _data.data.business_income,
                    service_experience_number: _data.data.service_experience_number,
                    exponent: _data.data.exponent || 0,
                    exponent_desc: _data.data.exponent_desc,
                    exponent_file: _data.data.exponent_file ? JSON.parse(_data.data.exponent_file) : [],
                    corps_credit: _data.data.corps_credit || 0,
                    corps_credit_desc: _data.data.corps_credit_desc,
                    corps_credit_file: _data.data.corps_credit_file ? JSON.parse(_data.data.corps_credit_file) : [],
                    association_credit: _data.data.association_credit || 0,
                    association_credit_desc: _data.data.association_credit_desc,
                    association_credit_file: _data.data.association_credit_file ? JSON.parse(_data.data.association_credit_file) : [],
                    social_credit: _data.data.social_credit || 0,
                    social_credit_desc: _data.data.social_credit_desc,
                    social_credit_file: _data.data.social_credit_file ? JSON.parse(_data.data.social_credit_file) : [],
                    assessment: _data.data.assessment || 0,
                    assessment_desc: _data.data.assessment_desc,
                    assessment_file: _data.data.assessment_file ? JSON.parse(_data.data.assessment_file) : [],
                    is_legislation: _data.data.is_legislation || 0,
                    legislation_desc: _data.data.legislation_desc,
                    legislation_file: _data.data.legislation_file ? JSON.parse(_data.data.legislation_file) : [],
                    is_policy: _data.data.is_policy || 0,
                    policy_desc: _data.data.policy_desc,
                    policy_file: _data.data.policy_file ? JSON.parse(_data.data.policy_file) : [],
                    is_standard: _data.data.is_standard || 0,
                    standard_desc: _data.data.standard_desc,
                    standard_file: _data.data.standard_file ? JSON.parse(_data.data.standard_file) : [],
                    is_market: _data.data.is_market || 0,
                    market_desc: _data.data.market_desc,
                    market_file: _data.data.market_file ? JSON.parse(_data.data.market_file) : [],
                    is_investigation: _data.data.is_investigation || 0,
                    investigation_desc: _data.data.investigation_desc,
                    investigation_file: _data.data.investigation_file ? JSON.parse(_data.data.investigation_file) : [],
                    standards: _data.data.standards || 0,
                    standards_desc: _data.data.standards_desc,
                    standards_file: _data.data.standards_file ? JSON.parse(_data.data.standards_file) : [],
                    landmarks: _data.data.landmarks || 0,
                    landmarks_desc: _data.data.landmarks_desc,
                    landmarks_file: _data.data.landmarks_file ? JSON.parse(_data.data.landmarks_file) : [],
                    make_group: _data.data.make_group || 0,
                    make_group_desc: _data.data.make_group_desc,
                    make_group_file: _data.data.make_group_file ? JSON.parse(_data.data.make_group_file) : [],
                    association_association: Number(_data.data.association_association || 0),
                    association_association_desc: _data.data.association_association_desc,
                    association_association_file: _data.data.association_association_file ? JSON.parse(_data.data.association_association_file) : [],
                    scene_check: _data.data.scene_check || 0,
                    scene_check_desc: _data.data.scene_check_desc,
                    scene_check_file: _data.data.scene_check_file ? JSON.parse(_data.data.scene_check_file) : [],
                    propaganda_last: _data.data.propaganda_last || 0,
                    propaganda_last_num: _data.data.propaganda_last_num,
                    propaganda_this: _data.data.propaganda_this || 0,
                    propaganda_this_num: _data.data.propaganda_this_num,
                    recommend_last: _data.data.recommend_last || 0,
                    recommend_last_num: _data.data.recommend_last_num,
                    recommend_this: _data.data.recommend_this || 0,
                    recommend_this_num: _data.data.recommend_this_num,
                    contact_member_last: _data.data.contact_member_last || 0,
                    contact_member_last_num: _data.data.contact_member_last_num,
                    contact_member_this: _data.data.contact_member_this || 0,
                    contact_member_this_num: _data.data.contact_member_this_num,
                    contact_person: _data.data.contact_person || _data.data.tel_name,
                    contact_phone: _data.data.contact_phone || _data.data.tel_number,
                    higher_level: _data.data.higher_level ? Number(_data.data.higher_level) : '',
                    higher_level_info: _data.data.higher_level ? this.getHigherLevel(Number(_data.data.higher_level)) : {},
                    lower_level: lower_level,
                    lower_level_info: lower_level.length > 0 ? this.getLowerLevel(lower_level) : [],
                    introduction_unit_ids: _data.data.introduction_unit_ids ? _data.data.introduction_unit_ids.split(',') : [],
                    interactive_information: _data.data.interactive_information ? JSON.parse(_data.data.interactive_information) : [],
                    related_information: _data.data.related_information ? JSON.parse(_data.data.related_information) : [],
                }
            }
            this.$nextTick(() => {
                this.$refs.infoForm.clearValidate()
            })
        },
        async getCheckLogList() {
            let _data = await getCheckLogList(this.log_page, this.limit)
            this.log_tableData = _data.data.data
            this.log_total = _data.data.total
        },
        async getFeedBackList() {
            let _data = await getFeedBackList(this.feedback_page, this.limit)
            this.feedback_tableData = _data.data.data
            this.feedback_total = _data.data.total
        },
        //  提交
        async submit(state) {
            let _state = await addCredit('keep_credit',
                this.id,
                this.infoForm.register_capital,
                this.infoForm.register_years,
                this.infoForm.social_security_number,
                this.infoForm.member_years,
                JSON.stringify(this.infoForm.practice_condition_file),
                JSON.stringify(this.infoForm.information_qualification_file),
                JSON.stringify(this.infoForm.education_and_training_file),
                JSON.stringify(this.infoForm.lampblack_file),
                JSON.stringify(this.infoForm.fire_products_file),
                JSON.stringify(this.infoForm.construction_construction_file),
                JSON.stringify(this.infoForm.patent_certificate),
                JSON.stringify(this.infoForm.government_projects),
                JSON.stringify(this.infoForm.association_project),
                JSON.stringify(this.infoForm.industry_certification),
                JSON.stringify(this.infoForm.above_related),
                JSON.stringify(this.infoForm.fire_products_features),
                JSON.stringify(this.infoForm.fire_services_features),
                this.infoForm.management_number,
                this.infoForm.business_income,
                this.infoForm.service_experience_number,
                this.infoForm.exponent,
                JSON.stringify(this.infoForm.exponent_file),
                this.infoForm.exponent_desc,
                this.infoForm.corps_credit,
                JSON.stringify(this.infoForm.corps_credit_file),
                this.infoForm.corps_credit_desc,
                this.infoForm.association_credit,
                JSON.stringify(this.infoForm.association_credit_file),
                this.infoForm.association_credit_desc,
                this.infoForm.social_credit,
                JSON.stringify(this.infoForm.social_credit_file),
                this.infoForm.social_credit_desc,
                this.infoForm.assessment,
                JSON.stringify(this.infoForm.assessment_file),
                this.infoForm.assessment_desc,
                this.infoForm.is_legislation,
                JSON.stringify(this.infoForm.legislation_file),
                this.infoForm.legislation_desc,
                this.infoForm.is_policy,
                JSON.stringify(this.infoForm.policy_file),
                this.infoForm.policy_desc,
                this.infoForm.is_standard,
                JSON.stringify(this.infoForm.standard_file),
                this.infoForm.standard_desc,
                this.infoForm.is_market,
                JSON.stringify(this.infoForm.market_file),
                this.infoForm.market_desc,
                this.infoForm.is_investigation,
                JSON.stringify(this.infoForm.investigation_file),
                this.infoForm.investigation_desc,
                this.infoForm.standards,
                JSON.stringify(this.infoForm.standards_file),
                this.infoForm.standards_desc,
                this.infoForm.landmarks,
                JSON.stringify(this.infoForm.landmarks_file),
                this.infoForm.landmarks_desc,
                this.infoForm.make_group,
                JSON.stringify(this.infoForm.make_group_file),
                this.infoForm.make_group_desc,
                this.infoForm.association_association,
                JSON.stringify(this.infoForm.association_association_file),
                this.infoForm.association_association_desc,
                this.infoForm.scene_check,
                JSON.stringify(this.infoForm.scene_check_file),
                this.infoForm.scene_check_desc,
                this.infoForm.propaganda_last,
                this.infoForm.propaganda_last ? this.infoForm.propaganda_last_num : '',
                this.infoForm.propaganda_this,
                this.infoForm.propaganda_this_num ? this.infoForm.propaganda_this_num : '',
                this.infoForm.recommend_last,
                this.infoForm.recommend_last_num ? this.infoForm.recommend_last_num : '',
                this.infoForm.recommend_this,
                this.infoForm.recommend_this_num ? this.infoForm.recommend_this_num : '',
                this.infoForm.contact_member_last,
                this.infoForm.contact_member_last_num ? this.infoForm.contact_member_last_num : '',
                this.infoForm.contact_member_this,
                this.infoForm.contact_member_this_num ? this.infoForm.contact_member_this_num : '',
                this.infoForm.higher_level,
                this.infoForm.higher_level ? Number(this.infoForm.higher_level_info.level) + 1 : '',
                this.infoForm.lower_level.join(','),
                this.infoForm.introduction_unit_ids.join(','),
                JSON.stringify(this.infoForm.interactive_information),
                JSON.stringify(this.infoForm.related_information),
                this.infoForm.contact_person,
                this.infoForm.contact_phone,
                state)
            if (_state.status === 200) {
                if (state) {
                    this.state = 1
                    this.readonly = true
                }
                this.$message.success('保存成功')
            }

        },
        addFeedback(data, index) {
            this.cur_index = index
            this.showContentDialog = true
            if (data) {
                this.ruleContentForm = {
                    content: data.content,
                }
            } else {
                this.ruleContentForm = {
                    content: '',
                }
            }
        },
        submitContentForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitContent()
                } else {
                    this.$message.error('信息填写不完整，请检查修改！')
                }
            })
        },
        async submitContent() {
            let _data = await addFeedback(this.cur_index === -1 ? '' : this.cur_index, this.ruleContentForm.content)
            if (_data.status === 200) {
                this.$message.success('保存成功')
                this.resetForm()
                this.feedback_page = 1
                await this.getFeedBackList()
            }
        },
        delFeedback(id) {
            this.$confirm('此操作将删除选择的信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delFeedbackItem(id)
            })
        },
        async delFeedbackItem(id) {
            let _data = await delFeedback(id)
            if (_data.status === 200) {
                await this.getFeedBackList()
                this.$message.success('删除成功')
            }
        },
        addFireProductsFeatures(data, index) {
            this.cur_index = index
            this.showFireProductsFeaturesDialog = true
            this.productList.map(item => {
                item.children.map(child => {
                    child.children.map(cate => {
                        cate.disabled = this.infoForm.fire_products_features.some(s => s.classify === child.value && item.value === s.type && cate.value === s.cate)
                    })
                })
            })
            if (data) {
                this.ruleFireProductsFeaturesForm = {
                    type: data.type,
                    classify: data.classify,
                    cate: data.cate,
                }
            } else {
                this.ruleFireProductsFeaturesForm = {
                    type: '',
                    classify: '',
                    cate: '',
                }
            }

        },
        submitFireProductsFeaturesForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.infoForm.fire_products_features.push({
                        type: this.ruleFireProductsFeaturesForm.type[0],
                        classify: this.ruleFireProductsFeaturesForm.type[1],
                        cate: this.ruleFireProductsFeaturesForm.type[2],
                        content: '',
                        file: []
                    })
                    this.resetForm()
                } else {
                    this.$message.error('信息填写不完整，请检查修改！')
                }
            })
        },
        delFireProductsFeaturesItem(index) {
            this.$confirm('此操作将删除选择的信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.infoForm.fire_products_features.splice(index, 1)
            })
        },
        addFireServicesFeatures(data, index) {
            this.cur_index = index
            this.showFireServicesFeaturesDialog = true
            this.supply.map(item => {
                item.disabled = this.infoForm.fire_services_features.some(s => s.type === item.value)
            })
            if (data) {
                this.ruleFireServicesFeaturesForm = {
                    type: data.type,
                }
            } else {
                this.ruleFireServicesFeaturesForm = {
                    type: '',
                }
            }

        },
        submitFireServicesFeaturesForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.infoForm.fire_services_features.push({
                        type: this.ruleFireServicesFeaturesForm.type,
                        content: '',
                        file: []
                    })
                    this.resetForm()
                } else {
                    this.$message.error('信息填写不完整，请检查修改！')
                }
            })
        },
        delFireServicesFeaturesItem(index) {
            this.$confirm('此操作将删除选择的信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.infoForm.fire_services_features.splice(index, 1)
            })
        },
        addIntroduction(data, index) {
            this.cur_index = index
            this.showIntroductionDialog = true
            if (data) {
                this.ruleIntroductionForm = {
                    id: data.id,
                }
            } else {
                this.ruleIntroductionForm = {
                    id: '',
                }
            }

        },
        submitIntroductionForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.infoForm.introduction_unit_ids.push(this.ruleIntroductionForm.id)
                    this.resetForm()
                } else {
                    this.$message.error('信息填写不完整，请检查修改！')
                }
            })
        },
        delIntroduction(index) {
            this.$confirm('此操作将删除选择的信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.infoForm.introduction_unit_ids.splice(index, 1)
            })
        },
        addInteractive(data, index) {
            this.cur_index = index
            this.showInteractiveDialog = true
            if (data) {
                this.ruleInteractiveForm = {
                    title: data.title,
                    label: data.label,
                    time: data.time,
                    content: data.content,
                }
            } else {
                this.ruleInteractiveForm = {
                    title: '',
                    label: '',
                    time: '',
                    content: '',
                }
            }

        },
        submitInteractiveForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.cur_index !== -1) {
                        this.infoForm.interactive_information.splice(this.cur_index, 1, this.ruleInteractiveForm);
                    } else {
                        this.infoForm.interactive_information.push(this.ruleInteractiveForm);
                    }
                    this.resetForm()
                } else {
                    this.$message.error('信息填写不完整，请检查修改！')
                }
            })
        },
        resetForm() {
            this.cur_index = -1
            this.showContentDialog = false
            this.showFireProductsFeaturesDialog = false
            this.showFireServicesFeaturesDialog = false
            this.showIntroductionDialog = false
            this.showInteractiveDialog = false
            this.showRelatedDialog = false
        },
        delInteractive(index) {
            this.$confirm('此操作将删除选择的互动信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.infoForm.interactive_information.splice(index, 1)
            })

        },
        addRelated(data, index) {
            this.cur_index = index
            this.showRelatedDialog = true
            if (data) {
                this.ruleRelatedForm = {
                    post: data.post,
                    time: data.time,
                    content: data.content,
                }
            } else {
                this.ruleRelatedForm = {
                    post: '',
                    time: '',
                    content: '',
                }
            }

        },
        submitRelatedForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.cur_index !== -1) {
                        this.infoForm.related_information.splice(this.cur_index, 1, this.ruleRelatedForm);
                    } else {
                        this.infoForm.related_information.push(this.ruleRelatedForm);
                    }
                    this.resetForm()
                } else {
                    this.$message.error('信息填写不完整，请检查修改！')
                }
            })
        },
        delRelated(index) {
            this.$confirm('此操作将删除选择的关联信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.infoForm.related_information.splice(index, 1)
            })

        },
        //  提交前验证
        submitForm(formName, state) {
            if (state) {
                this.$refs[formName].validate((valid, validates) => {
                    if (valid) {
                        this.submit(state)
                    } else {
                        let error = _reduce(Object.values(validates))
                        let isFile = error.every(e => e.message.indexOf('请上传') !== -1)
                        if (isFile) {
                            this.submit(state)
                        } else {
                            this.$message.error('信息填写不完整，请检查修改！');
                            this.$nextTick(() => {
                                this.$refs.info.scrollTo(0, 0);
                            });
                        }
                    }
                });
            } else {
                this.submit(state)
            }

        },
        //  删除上传文件
        handleRemove(file, fileList, type, index = -1, child = -1) {
            console.log(file)
            console.log(fileList)
            switch (index) {
                case -1:
                    this.infoForm[type] = fileList
                    break
                case -2:
                    this.infoForm[type].file = fileList
                    break
                default :
                    if (child !== -1) {
                        this.infoForm[type][index].content[child].file = fileList;
                    } else {
                        this.infoForm[type][index].file = fileList;
                    }
                    break
            }
        },

        //  上传成功 index -1 普通上传 -2 对象.file 上传 0-～ 为列表上传
        uploadSuccess(response, file, fileList, type, index = -1, child = -1) {
            console.log(fileList)
            if (response.status === 200) {
                switch (index) {
                    case -1:
                        this.infoForm[type].push({
                            name: file.name,
                            url: this.showhost + response.url,
                            path: response.url
                        })
                        break
                    case -2:
                        this.infoForm[type].file.push({
                            name: file.name,
                            url: this.showhost + response.url,
                            path: response.url
                        })
                        break
                    default :
                        if (child !== -1) {
                            this.infoForm[type][index].content[child].file.push({
                                name: file.name,
                                url: this.showhost + response.url,
                                path: response.url
                            })
                        } else {
                            this.infoForm[type][index].file.push({
                                name: file.name,
                                url: this.showhost + response.url,
                                path: response.url
                            })
                        }
                        break
                }
            }
        },
        //上传文件预览
        handlePreview(file) {
            window.open(file.url)
        },
        classifyChange(e, type, classify) {
            // if (e.length === 0 || e[e.length - 1] === 0) {
            if (e.length === 0) {
                this.infoForm[type].length = 0
            } else {
                if (this.infoForm[type].length > e.length) {
                    this.infoForm[type] = this.infoForm[type].filter(item => {
                        return e.indexOf(Number(item.id)) !== -1
                    })
                } else {
                    let find = this[classify].find(item => {
                        return item.value === e[e.length - 1]
                    })
                    this.infoForm[type].push({
                        id: e[e.length - 1],
                        name: find.label,
                        content: [{
                            name: '',
                            file: []
                        }],
                        file: []
                    })
                }
            }
        },
        addItem(type, index) {
            this.infoForm[type][index].content.push({
                name: '',
                file: []
            })
        },
        delItem(type, index, child) {
            this.$confirm('此操作将删除选择的信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.infoForm[type][index].content.splice(child, 1)
            })
        },
        higherLevelChange(e) {
            // this.infoForm.lower_level = []
            // this.infoForm.lower_level_info = []
            if (e) {
                this.infoForm.higher_level_info = this.getHigherLevel(e)
            } else {
                this.infoForm.higher_level_info = {}
            }
        },
        getHigherLevel(id) {
            return this.oneLevelLabels.find(item => Number(item.id) === id)
        },
        lowerLevelChange(e) {
            if (e.length !== 0) {
                this.infoForm.lower_level_info = this.getLowerLevel(e)
            } else {
                this.infoForm.lower_level_info = []
            }
        },
        getLowerLevel(ids) {
            return this.oneLevelLabels.filter(item => {
                return ids.indexOf(Number(item.id)) !== -1
            })
        },
        exportExcel() {
            window.open(`${UDHOST}/api/Credit/lowCompanyExport?token=${getToken()}`)
        }
    },
    filters: {
        interactive_label(type, labels) {
            let find = labels.find(item => Number(item.id) === Number(type))
            return find ? find.title : ''
        },
        related_label(type, labels) {
            let find = labels.find(item => item.user_id === Number(type))
            return find ? find.company_name : ''
        },
        introduction_unit(type, labels) {
            let find = labels.find(item => item.user_id === Number(type))
            return find ? find.company_name : ''
        },
        fire_services_features_type(type) {
            let find = supply.find(item => item.value === Number(type))
            return find ? find.label : ''
        },
        fire_products_features_type(type) {
            let find = productList.find(item => item.value === Number(type))
            return find ? find.label : ''
        },
        fire_products_features_classify(classify, type) {
            let find = productList.find(item => item.value === Number(type))
            if (!find) return ''
            let child = find.children.find(item => item.value === Number(classify))
            return child ? child.label : ''
        },
        fire_products_features_cate(cate,classify, type) {
            let find = productList.find(item => item.value === Number(type))
            if (!find) return ''
            let child = find.children.find(item => item.value === Number(classify))
            if (!child) return ''
            child = child.children.find(item => item.value === Number(cate))
            return child ? child.label : ''
        }
    },
    watch: {},
}
</script>

<style lang="scss" scoped>

.info {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    height: calc(100vh - 180px);
    overflow: auto;

    .reason {
        background: #0dc928;
        padding: 15px 20px;
        font-size: 16px;

        &.red {
            background: #e4393c;
            color: #FFFFFF!important;
        }

        span {
            color: #ffffff;
        }
    }

    .other {
        border-bottom: 1px solid #eeeeee;
    }

    .mune-title {
        font-size: 16px;
        color: #0d7fd7;
        padding-left: 20px;
        position: relative;
        line-height: 24px;

        &.first {
            font-size: 20px;

            &:before {
                position: absolute;
                top: 0;
                left: 0;
                content: "";
                width: 5px;
                height: 24px;
                background-color: #0d7fd7;
                border-radius: 2px;
            }
        }
    }

    .xieyi {
        font-size: 14px;
        line-height: 24px;
        padding-left: 50px;
        color: #666;

        p {
            text-indent: 32px;
        }
    }

    .agree {
        width: 220px;
        margin: 0 auto;
    }
}
</style>
